import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VMessage} from "../../models/v-message.model";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VMessageService} from "../../providers/v-message.service";
import {UserTag} from "../../models/user-tag.model";
import {UserTagsService} from "../../providers/user-tags.service";
import {User} from "../../models/user.model";
import {UserService} from "../../providers/user.service";
import {Subscription} from "rxjs";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {VetClinic, VImage} from "../../models/vet-clinic.model";
import {environment} from "../../../environments/environment";
import {ClientsService} from "../../providers/clients.service";
import {FileService} from "../../providers/file.service";
import {Client} from "../../models/client.model";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import Quill from 'quill';
import {VetClinicService} from "../../providers/vet-clinic.service";

@Component({
  selector: 'app-v-message',
  templateUrl: './v-message.component.html',
  styleUrls: ['./v-message.component.scss'],
})
export class VMessageComponent implements OnInit {

  @Input() vMsg: VMessage;
  @Input() isShowForm: boolean;
  @Input() csrfToken: string;
  @Input() selectedUserUUID: string;

  @Output() cancelEmitter = new EventEmitter<boolean>();
  @Output() objectAddedEmitter = new EventEmitter<string>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  formGroup: FormGroup;
  public hasUnsavedChanges = false;
  tags: UserTag[];
  showUsers: boolean = false;
  users: User[];
  user: User;
  isBusy: boolean;
  isBusySub: Subscription;
  imgUUID: string;
  folderUUID: string = environment.VETINEO_ADMIN_CLINIC_UUID;
  msgImg: VImage;
  images: VImage[];
  addPicture: boolean;
  useVClinicPicture: boolean;
  selectedClient: Client;
  clinics: VetClinic[];
  isGeneralAdmin: boolean;
  isAdmin: boolean;
  isClinicAdmin: boolean;
  vClientUUID: string;
  sendMultipleClinics: boolean = false;
  @Input()
  fromUserDG: boolean;
  vMessage: VMessage;
  canBeSend: boolean = false;
  imageFolder: string;
  // @ViewChild('editor') editor: QuillEditorComponent;
  // modules = {
  //   toolbar: {
  //     container: [
  //       ['bold', 'italic', 'underline'],        // toggled buttons
  //       [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  //       [{ 'header': [1, 2, 3, 4, 5, 6, false] }]
  //     ]
  //   }
  // };
  isHTMLToggle: boolean;
  textAreaValue: string;
  private quill: Quill;
  private clinicSub: Subscription;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private vMessageService: VMessageService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private userTagService: UserTagsService,
    private userService: UserService,
    private clientService: ClientsService,
    private fileService: FileService,
    private vetClinicService: VetClinicService
  ) {
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.addPicture = false;
    this.useVClinicPicture = false;
    this.isBusySub = this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });
    this.userService.getUser().subscribe(e => {
      if (e) {
        this.user = e;
        this.isAdmin = this.filterRoleContains(e, 'admin');
        this.isGeneralAdmin = this.isAdmin && e.vClientId === null && e.vetcodeId === null;
        this.isClinicAdmin = this.isAdmin && e.vClientUUID !== null;
        this.vClientUUID = e.vClientUUID;
        if (e.vetcodeId) {
          this.clientService.getClinicInfo().subscribe(cl => {
            if (cl && cl.uuid) {
              this.folderUUID = cl.uuid;
            }
          });
        } else {
          if (e.vClientUUID) {
            this.selectClient(e.vClientUUID);
          }
        }
      }
    });

    if (this.vMsg?.uuid) {
      this.formGroup = this.formBuilder.group({
        subject: [this.vMsg.subject, Validators.required],
        content: ['', Validators.required],
        msgImageUUID: ['']
      });

    } else {
      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      });
    }

    this.appStateService.updateIsBusySubject(false);
  }

  onAnswer() {
    this.isShowForm = false;
  }

  onClose() {
    this.vMsg = null;
    this.cancelEmitter.emit(true);
  }

  onCancel() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz wyjść?', 'Tak', 'Nie', 'checkmark', 'close',
      () => {
        if (this.msgImg) {
          this.deletePicture();
        }
        this.vMsg = null;
        this.cancelEmitter.emit(true);
      }, () => {
      });
  }

  deletePicture() {
    this.appStateService.updateIsBusySubject(true);
    this.fileService.deleteFromCdn(this.imgUUID).subscribe(e => {
      console.log(e);
      if (e) {
        this.imgUUID = null;
        this.msgImg = null;
        this.formGroup.get('msgImageUUID').setValue('');
        this.commonUtils.presentInfoToast('Usunięto plik')
        this.appStateService.updateIsBusySubject(false);
        this.addPicture = !this.addPicture;

      } else {
        this.commonUtils.presentAlertToast('Wystąpił bład podczas usuwania pliku')
        this.appStateService.updateIsBusySubject(false);

      }
    })
  }

  onSend() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz wysłać wiadomość?', 'Tak', 'Nie', 'checkmark', 'close',
      () => {
        this.appStateService.updateIsBusySubject(true);
        let vMessageToSend: VMessage = this.commonUtils.formGroupValuesToObject<VMessage>(new VMessage(), this.formGroup);
        // vMessageToSend.content = this.textAreaValue;
        vMessageToSend.type = 'DASHBOARD';
        if (this.imgUUID) {
          vMessageToSend.msgImageUUID = this.imgUUID;
        } else {
          vMessageToSend.msgImageUUID = null;
        }

        vMessageToSend.fromEmail = this.user?.email || '';

        if (this.vMsg?.uuid) {
          vMessageToSend.userUUID = this.vMsg.userUUID;
          vMessageToSend.vetReservationUUID = this.vMsg.vetReservationUUID;
        }
        if (this.selectedUserUUID) {
          vMessageToSend.userUUID = this.selectedUserUUID
        }
        this.vMessageService.send(vMessageToSend).subscribe(res => {
          if (res) {
            this.appStateService.updateIsBusySubject(false);
            this.objectAddedEmitter.emit(res);
            this.commonUtils.presentInfoToast("Wiadomość została wysłana");
          } else {
            this.commonUtils.presentAlertToast("Wiadomość nie została wysłana");
          }
          this.appStateService.updateIsBusySubject(false);

        }, error => {
          if (error.message == 'SMS_MODULE_NOT_ENABLED') {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast('Moduł sms w KliniceXp wygasł')
          } else {
            if (error.message == 'USER_WAS_DELETED') {
              this.appStateService.updateIsBusySubject(false);
              this.commonUtils.presentAlertToast('Użytkownik został usunięty, nie można wysłać wiadomości')
            } else {
              this.appStateService.updateIsBusySubject(false);
              this.commonUtils.presentAlertToast("Wiadomość nie została wysłana, wystąpił błąd");
            }
          }
        })
      }, () => {
        this.commonUtils.presentAlertToast("Wiadomość nie została wysłana");
      })
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.appStateService.updateEditMode("CHANGED");
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  onShowUsers() {
    this.appStateService.updateIsBusySubject(true);
    this.showUsers = !this.showUsers;
    this.tags = null;
    if (this.showUsers) {
      if (this.formGroup) {
        this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
      }

      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        userUUID: [this.vMessage?.userUUID, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      });
      this.appStateService.updateIsBusySubject(false);

    } else {
      if (this.formGroup) {
        this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
        this.vMessage.userUUID = null;
      }

      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      })
      this.appStateService.updateIsBusySubject(false);

    }
  }

  onShowTags() {
    this.appStateService.updateIsBusySubject(true);
    if (this.tags) {
      this.tags = null;
      if (this.formGroup) {
        this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
      }

      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      })
      this.appStateService.updateIsBusySubject(false);

    } else {
      this.userTagService.getTags().subscribe(e => {
        if (e) {
          this.tags = e;
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);
      });

      if (this.formGroup) {
        this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
      }

      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        tagsUUIDs: [this.vMessage?.tagsUUIDs, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      });
      this.appStateService.updateIsBusySubject(false);

    }
  }

  onKey($event) {
    let search = $event.target.value;
    if (search.length > 3) {
      this.appStateService.updateIsBusySubject(true);
      this.userService.listUsersToSendMsg(this.vClientUUID, search).subscribe(e => {
        if (e && e.length > 0) {
          this.users = e;
          this.appStateService.updateIsBusySubject(false);

        } else {
          this.users = null;
          this.appStateService.updateIsBusySubject(false);

          this.commonUtils.presentSimpleInfoToast('Nie znaleziono użytkownika', 'bottom', 5);
        }
      })
    }
  }

  async openImageDropForPhoto(formControlName: 'msgImageUUID', imageFolder: string) {
    let vClinicUUID = this.folderUUID;
    if (this.user) {
      if (this.filterRoleContains(this.user, 'admin') && !this.user.vClientId) {
        vClinicUUID = '';
      }
    }
    if (this.sendMultipleClinics) {
      const modal = await this.modalController.create({
        component: VImageDropComponent,
        componentProps: {
          'multiple': false,
          'vClientUUID': this.vClientUUID,
          'imageFolder': imageFolder,
          'vetClinicUUID': ''
        },
        backdropDismiss: false
      });

      modal.onDidDismiss<VImage>().then((dismissData) => {
        if (dismissData && dismissData.data !== null) {
          this.markUnsavedChanges();
          this.msgImg = dismissData.data;
          this.imgUUID = dismissData.data?.uuid;
          this.imageFolder = dismissData.data?.imageFolder;
          this.formGroup.get(formControlName).setValue(this.imgUUID);
          this.markUnsavedChanges();
        }
      });
      return await modal.present();

    } else {
      const modal = await this.modalController.create({
        component: VImageDropComponent,
        componentProps: {
          'multiple': false,
          'vClientUUID': '',
          'imageFolder': imageFolder,
          'vetClinicUUID': vClinicUUID
        },
        backdropDismiss: false
      });

      modal.onDidDismiss<VImage>().then((dismissData) => {
        if (dismissData && dismissData.data !== null) {
          this.msgImg = dismissData.data;
          this.imgUUID = dismissData.data?.uuid;
          this.imageFolder = dismissData.data?.imageFolder;
          this.formGroup.get(formControlName).setValue(this.imgUUID);
          this.markUnsavedChanges();
        }
      });
      return await modal.present();

    }

  }

  ngOnDestroy(): void {
    this.user = null;
    if (this.isBusySub) this.isBusySub.unsubscribe();
  }

  filterRoleContains(user: User, role: string) {
    return user.roles?.split(';').filter(e => e === role).length === 1;
  }

  onAddPicture() {
    this.addPicture = !this.addPicture;
    if (this.vMsg && this.vMsg.msgImageUUID) {
      this.vMsg.msgImageUUID = null;
      this.vMsg.msgImage = null;
    }
    this.msgImg = null;
    this.imgUUID = null;
  }

  cancelSending() {
    this.addPicture = !this.addPicture;
    this.useVClinicPicture = false;
    if (this.vMsg && this.vMsg.msgImageUUID) {
      this.vMsg.msgImageUUID = null;
      this.vMsg.msgImage = null;
    }
    this.msgImg = null;
    this.imgUUID = null;
  }

  onUsePictureFromClinic() {
    this.appStateService.updateIsBusySubject(true);
    this.useVClinicPicture = !this.useVClinicPicture;
    if (!this.msgImg) {
      this.vMessageService.getDefaultClinicImg().subscribe(e => {
        if (e) {
          this.addPicture = true;
          if (this.vMsg) {
            this.vMsg.msgImageUUID = e.uuid;
            this.vMsg.msgImage = e;
          }
          this.msgImg = e;
          this.imgUUID = e.uuid;
          this.imageFolder = e.imageFolder;
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);

      })
    } else {
      this.addPicture = false;
      if (this.vMsg) {
        this.vMsg.msgImageUUID = null;
        this.vMsg.msgImage = null;
      }
      this.msgImg = null;
      this.imageFolder = null;
      this.imgUUID = null;
    }
    this.appStateService.updateIsBusySubject(false);
  }

  selectClient(uuid: string) {
    this.appStateService.updateIsBusySubject(true);
    this.vClientUUID = uuid;

    if (this.isGeneralAdmin) {
      this.clinicSub = this.vetClinicService.listClinicsForClient(this.vClientUUID).subscribe(e => {
        if (e) {
          this.clinics = e;

          if (this.formGroup) {
            this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
          }

          this.formGroup = this.formBuilder.group({
            subject: [this.vMessage?.subject, Validators.required],
            content: [this.vMessage?.content, Validators.required],
            clinics: [this.vMessage?.clinics, Validators.required],
            msgImageUUID: [this.vMessage?.msgImageUUID]
          });
        }

        this.appStateService.updateIsBusySubject(false);
      });
    } else {
      this.clientService.listAllClinicsWithMessagesEnabled(this.vClientUUID).subscribe(e => {
        if (e) {
          this.clinics = e;

          if (this.formGroup) {
            this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
          }

          this.formGroup = this.formBuilder.group({
            subject: [this.vMessage?.subject, Validators.required],
            content: [this.vMessage?.content, Validators.required],
            clinics: [this.vMessage?.clinics, Validators.required],
            msgImageUUID: [this.vMessage?.msgImageUUID]
          });
        }

        this.appStateService.updateIsBusySubject(false);
      });
    }

  }


  onSelectMultipleClinics() {
    this.appStateService.updateIsBusySubject(true);
    this.sendMultipleClinics = !this.sendMultipleClinics;
    this.tags = null;
    if (this.sendMultipleClinics) {
      this.clientService.listAllClinicsWithMessagesEnabled(this.vClientUUID).subscribe(e => {
        if (e) {
          this.clinics = e;

          if (this.formGroup) {
            this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
          }

          this.formGroup = this.formBuilder.group({
            subject: [this.vMessage?.subject, Validators.required],
            content: [this.vMessage?.content, Validators.required],
            clinics: [this.vMessage?.clinics, Validators.required],
            msgImageUUID: [this.vMessage?.msgImageUUID]
          });
          this.appStateService.updateIsBusySubject(false);
        }
      });
    } else {
      this.clinics = null;

      if (this.formGroup) {
        this.vMessage = this.commonUtils.formGroupValuesInputedToObject<VMessage>(new VMessage(), this.formGroup);
      }

      this.formGroup = this.formBuilder.group({
        subject: [this.vMessage?.subject, Validators.required],
        content: [this.vMessage?.content, Validators.required],
        msgImageUUID: [this.vMessage?.msgImageUUID]
      });
      this.appStateService.updateIsBusySubject(false);
    }
  }

  getTitle(): string {
    if (this.vMsg && this.vMsg.uuid) {
      return 'Wysłana wiadomość';
    } else {
      return 'Nowa wiadomość';
    }
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients'
      }
    });
    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.selectedClient = data.data;
        this.selectClient(this.selectedClient.uuid);

      }
    });

    return await modal.present();
  }

  // changedEditor($event: any) {
  //   if ($event.html) {
  //     this.textAreaValue = $event.html.replace(new RegExp(/<p><br[\/]?><[\/]?p>/g),'<br>');
  //     const lines = this.textAreaValue.split('</p>');
  //     this.textAreaValue = lines.join('</p>\n');
  //     this.textAreaValue = this.textAreaValue.replace(new RegExp('\n$'), '');
  //
  //   }
  //   if($event.event === 'text-change') {
  //     this.markUnsavedChanges();
  //     this.formGroup.controls.content.markAsTouched();
  //   }
  // }
  //
  // onHTMLToggle($event) {
  //   this.isHTMLToggle = $event.detail.checked;
  // }
  //
  // textAreaChange($event) {
  //   this.textAreaValue = $event.detail.value;
  // }
  // onSaveHTML() {
  //   this.formGroup.controls.content.setValue(this.textAreaValue);
  // }
  //
  // onEditorCreated() {
  //   this.quill = this.editor.quillEditor;
  // }
}
